













































































































































import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import IsNotificationsCheckMixin from '@/mixins/isNotificationsCheck';
import { notificationsService } from '@/services';
import { MenuRouting, IProfileMenu } from './types';
import { NOTIFICATION, USER_SIGNOUT } from './consts';
import { isViewedEvent } from '../modules/notification';
import AppTooltip from '@/uikit/components/AppTooltip/AppTooltip';

@Component({
  components: {
    AppTooltip,
  },
})
export default class ProfileMenu
  extends Mixins(IsNotificationsCheckMixin)
  implements IProfileMenu
{
  @Inject() $api: AxiosInstance;

  readonly cabinet: string = MenuRouting.CABINET;
  readonly settings: string = MenuRouting.SETTINGS;
  readonly notifications: string = MenuRouting.NOTIFICATIONS;
  readonly mentoring: string = MenuRouting.MENTORING;
  unreadCounter = 0;

  get isActiveCabinet(): boolean {
    return this.$route.matched.some((record) => record.meta.isInnerRoutes);
  }

  get isActiveSettings(): boolean {
    return this.$route.matched.some(
      (record) => record.meta.isInnerSettingsRoutes
    );
  }

  get isActiveMentoring(): boolean {
    return this.$route.path!.includes(MenuRouting.REQUESTS);
  }

  get isActiveNotifications(): boolean {
    return this.$route.path!.includes(NOTIFICATION);
  }

  get unreadCount(): string | number {
    const { unreadCounter } = this;
    if (!unreadCounter) return '';
    return unreadCounter > 9 ? '9+' : unreadCounter;
  }

  get viewedEvent(): boolean {
    return isViewedEvent.event;
  }

  @Watch('viewedEvent')
  startGetUnread(value: boolean) {
    if (value && this.isNotificationsModule) this.getUnread();
  }

  created() {
    if (this.isNotificationsModule) {
      this.getUnread();
    }
  }

  logout(): void {
    this.$router.replace({ path: '/' }, () => {
      this.$store.dispatch(USER_SIGNOUT);
    });
  }

  async getUnread(): Promise<void> {
    try {
      const { unread } = await notificationsService(
        this.$api
      ).getNotificationsUnreadCount();
      this.unreadCounter = unread;
      if (this.viewedEvent) isViewedEvent.event = false;
    } catch (err) {
      this.unreadCounter = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/profilemenu/ProfileMenu.vue